import type { ModernSubscription } from '../../types';
import { SubscriptionStates } from '../../types';

export function hasSubscription(modernSubscription: ModernSubscription) {
  const { state } = modernSubscription;
  return [
    SubscriptionStates.ACTIVE_SUBSCRIPTION,
    SubscriptionStates.ACTIVE_TRIAL_WITH_SUBSCRIPTION,
    SubscriptionStates.FAILED_PAYMENT_SUBSCRIPTION,
    SubscriptionStates.LAPSED_SUBSCRIPTION,
    SubscriptionStates.USAGE_EXCEEDED_GRACE_PERIOD,
    SubscriptionStates.USAGE_EXCEEDED_READ_ONLY,
  ].includes(state as SubscriptionStates);
}
